export default __webpack_public_path__ + "static/media/butchery-topic-hover.b6700e67.svg";